<h4 mat-dialog-title id="confirmation-title" matDialogTitle>{{ title }}</h4>

<mat-dialog-content>
  <p id="confirmation-message" class="whitespace-pre-line">{{ message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="'delete'">
      <button id="confirm-cancel" mat-raised-button (click)="dialogRef.close()">
        Cancel
      </button>
      <button id="confirm-delete" mat-raised-button color="warn" (click)="dialogRef.close(true)">
        Delete
      </button>
    </ng-container>

    <ng-container *ngSwitchCase="'ok'">
      <button id="confirm-ok" mat-raised-button color="primary" (click)="dialogRef.close(true)">
        OK
      </button>
    </ng-container>

    <ng-container *ngSwitchCase="'close'">
      <button id="confirm-close" mat-raised-button color="primary" (click)="dialogRef.close(null)">
        Close
      </button>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <button id="confirm-no" mat-raised-button (click)="dialogRef.close()">
        No
      </button>

      <button id="confirm-yes" mat-raised-button color="warn" (click)="dialogRef.close(true)">
        Yes
      </button>
    </ng-container>
  </ng-container>
</mat-dialog-actions>